import { gql } from "@apollo/client";

// Requête pour les points de ramassage (typeAoiId: 21)
export const GET_PICKUP_POINTS = gql`
  query GetPickupPoints($clientLoginId: Int!) {
    getLtmAois(typeAoiId: 21, clientLoginId: $clientLoginId) {
      id
      name
      longitude
      latitude
      radius
      geometry
      metaData
      status
      pluscode
      typeAoiId
      parentId
      typeAoi {
        id
        name
      }
      children {
        id
        name
        longitude
        latitude
        radius
        geometry
        metaData
        status
        pluscode
        typeAoiId
        typeAoi {
          id
          name
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

// Requête pour les écoles (typeAoiId: 24)
export const GET_SCHOOLS = gql`
  query GetSchools($clientLoginId: Int!) {
    getLtmAois(typeAoiId: 24, clientLoginId: $clientLoginId) {
      id
      name
      longitude
      latitude
      radius
      geometry
      metaData
      status
      pluscode
      typeAoiId
      parentId
      typeAoi {
        id
        name
      }
      children {
        id
        name
        longitude
        latitude
        radius
        geometry
        metaData
        status
        pluscode
        typeAoiId
        typeAoi {
          id
          name
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;


// Requête pour les écoles (typeAoiId: 2)
export const GET_REGIONS = gql`
  query GetSchools($clientLoginId: Int!) {
    getLtmAois(typeAoiId: 2, clientLoginId: $clientLoginId) {
      id
      name
      longitude
      latitude
      radius
      geometry
      metaData
      status
      pluscode
      typeAoiId
      parentId
      typeAoi {
        id
        name
      }
      children {
        id
        name
        longitude
        latitude
        radius
        geometry
        metaData
        status
        pluscode
        typeAoiId
        typeAoi {
          id
          name
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;



// Requête pour les zones de limitation (typeAoiId: 25, 26, 27, 28, 29)
export const GET_LIMITATION_ZONES = gql`
  query GetLimitationZones($clientLoginId: Int!) {
    getLtmAois(clientLoginId: $clientLoginId) {
      id
      name
      longitude
      latitude
      radius
      geometry
      metaData
      status
      pluscode
      typeAoiId
      parentId
      typeAoi {
        id
        name
      }
      children {
        id
        name
        longitude
        latitude
        radius
        geometry
        metaData
        status
        pluscode
        typeAoiId
        typeAoi {
          id
          name
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

// Requête pour l'historique de trajet d'un véhicule
export const GET_TRAVEL_HISTORY = gql`
  query GetTravelHistory($uniqueId: String!, $from: String!, $to: String!, $snapToRoad: Boolean) {
    getTravelHistory(
      uniqueId: $uniqueId
      from: $from
      to: $to
      snapToRoad: $snapToRoad
    ) {
      distanceTravelledKms
      points {
        ts
        lat
        lng
        speed
        isHA
        isHB
        address
      }
    }
  }
`;

// Requête pour récupérer tous les véhicules/devices
export const GET_DEVICES = gql`
  query getDevices {
    devices: getAllDeviceLocations {
      isNoGps
      isOffline
      speed
      uniqueId
      vehicleNumber
      vehicleType
      vehicleModel
      model_name
      timestamp
      latitude
      longitude
      haltStatus
      idlingStatus
      isOverspeed
      isPrimaryBattery
      extBatVol
      vehicleGroups
      address
      fuel_level
      intBatVol
      __typename
    }
  }
`;
